<template>
  <!--
    Layout is organized in 3 columns and a topbar
     __________________________________
    |      Welcome message             |
    |__________________________________|
     _________  _______________  ______
    |         ||               ||      |
    |   My    ||  All other    || Feed |
    | Projects||    cards      ||      |
    |         ||               ||      |
    |_________||_______________||______|
  -->
  <v-layout
    row
    wrap
  >
    <!-- My projects - Left column -->
    <v-flex
      lg3
      md4
      sm6
      xs12
    >
      <v-card>
        <v-card-title v-t="'projects.mine'" />

        <v-list>
          <v-list-item
            v-for="project in myProjects.models"
            :key="`my-project-${project.id}`"
            :to="{ name: 'project-details', params: { name: project.id } }"
          >
            <pa-user-avatar
              :image="project.image"
              :name="project.name"
            />
            <v-list-item-content>
              <v-list-item-title>{{ project.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-skeleton-loader
          v-if="myProjects.loading"
          loading
          transition="scale-transition"
          type="list-item-avatar"
        />

        <v-card-text v-else-if="!myProjects.length">
          <div
            v-t="'projects.none'"
            class="text-center grey--text"
          />
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-t="'projects.new'"
            block
            outlined
            color="primary"
            :to="{ name: 'project-new' }"
          />
        </v-card-actions>
      </v-card>
    </v-flex>

    <!-- All other cards - central column -->
    <v-flex
      xl7
      lg6
      md4
      sm6
      xs12
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xl4
          lg6
          xs12
        >
          <project-activities-summary mine />
        </v-flex>

        <v-flex
          v-for="(widget, i) in extensionsWidgets"
          :key="`widget-${i}`"
          xl3
          lg4
          md4
          sm6
          xs12
        >
          <component :is="widget" />
        </v-flex>
      </v-layout>
    </v-flex>

    <!-- Project Feed - right column -->
    <v-flex
      xl2
      lg3
      md4
      sm6
      xs12
    >
      <check-list
        v-if="showChecklist"
        :items="welcomeChecklist"
      />

      <project-feed
        v-if="false"
        organization
      />
    </v-flex>
  </v-layout>
</template>

<script>
import hopscotch from 'hopscotch'
import { mapState, mapActions } from 'vuex'

import { getTourById } from '@/components/help/HelpTours'
import HasWidgets from '@/mixins/HasWidgets'
import CheckList from '@/components/help/CheckList'
import ProjectFeed from '@/components/project/ProjectFeed'
import ProjectActivitiesSummary from '@/components/project/ProjectActivitiesSummary'
import Projects from '@/models/Projects'

export default {
  name: 'Home',
  components: {
    CheckList,
    ProjectActivitiesSummary,
    ProjectFeed
  },
  mixins: [ HasWidgets ],
  data () {
    return {
      myProjects: new Projects(),
      showChecklist: false,
      welcomeChecklist: []
    }
  },
  computed: {
    ...mapState('user', [ 'engagement' ])
  },
  async mounted () {
    hopscotch.listen('end', this.updateEngagement)

    await this.myProjects.fetch({
      users: this.$currentUser.id,
      organization: this.$currentOrganization.id
    })

    this.welcomeChecklist = [
      {
        name: 'What\'s your name?',
        done: this.$currentUser.profile.displayName,
        to: { name: 'user-profile' }
      },
      {
        name: 'Name your organization',
        done: this.$currentOrganization.name !== 'My Organization',
        to: { name: 'organization-settings' }
      },
      {
        name: 'Create your first project',
        done: this.myProjects.length > 0,
        to: { name: 'project-new' }
      },
      {
        name: 'Customize your preferences',
        done: Object.keys(this.$currentUser.preferences).length,
        to: { name: 'user-preferences' }
      }
    ]

    this.showChecklist = this.welcomeChecklist.some(i => !i.done)
  },
  beforeDestroy () {
    try {
      hopscotch.unlisten('end', this.updateEngagement)
    } catch (e) {}
  },
  methods: {
    ...mapActions('user', [ 'setEngagement' ]),
    startWelcomeTour () {
      hopscotch.startTour(getTourById('home'), 0)
    },
    updateEngagement () {
      this.setEngagement({ what: 'welcome', value: true })
    }
  }
}
</script>
